(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 30346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return __webpack_require__(55949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Prism; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Hero_Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/HeroBackground.js
var HeroBackground = __webpack_require__(30389);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Meta.js
var Meta = __webpack_require__(1041);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Image.js
var Image = __webpack_require__(66176);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/index.js + 1 modules
var Feature = __webpack_require__(55185);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(93816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSectionStripped.js
var SimpleSectionStripped = __webpack_require__(37045);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js + 1 modules
var PageNavbar = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Item.js
var Item = __webpack_require__(361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Link.js
var PageNavbar_Link = __webpack_require__(24661);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/WhatIsNew.js




const WhatIsNew = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            mx: true,
            my: true,
            utility: {
                align: {
                    items: "center"
                }
            },
            children: children
        })
    });
};
WhatIsNew.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var WhatIsNew_WhatIsNew = (WhatIsNew);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var atomic_react_Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/Image.js




const WhatIsNewImage = (param)=>{
    let { src , alt ="" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        sm: 12,
        md: 3,
        lg: 3,
        spacing: {
            mt: 10
        },
        sx: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Image/* default */.Z, {
            src: src,
            alt: alt,
            ...props
        })
    });
};
WhatIsNewImage.propTypes = {
    ...atomic_react_Image/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var WhatIsNew_Image = (WhatIsNewImage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/Content.js






const WhatIsNewContent = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        sm: 12,
        md: 9,
        lg: 9,
        children: children
    });
};
WhatIsNewContent.propTypes = {
    children: prop_types.node.isRequired
};
const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        Tag: "h4",
        sx: {
            fontSize: "m",
            fontColor: "white"
        },
        spacing: {
            mb: 4
        },
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Content_Description = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        color: "black--15",
        children: children
    });
};
Content_Description.propTypes = {
    children: prop_types.node.isRequired
};
WhatIsNewContent.Title = Title;
WhatIsNewContent.Description = Content_Description;
/* harmony default export */ var Content = (WhatIsNewContent);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(76136);
// EXTERNAL MODULE: ./src/services/index.js + 20 modules
var services = __webpack_require__(17104);
// EXTERNAL MODULE: ./src/SectionStart30DayTrial/index.js + 1 modules
var SectionStart30DayTrial = __webpack_require__(75611);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/AvailableOnOs.js





const AvailableOnOs = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "available-on-os",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            className: "available-on-os__container",
            children: children
        })
    });
};
AvailableOnOs.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var AvailableOnOs_AvailableOnOs = (AvailableOnOs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/Icon.js




const AvailableOnOsIconContainer = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            className: "available-on-os__icon-container",
            ...props
        })
    });
};
AvailableOnOsIconContainer.propTypes = {
    ...Grid/* Col.propTypes */.JX.propTypes
};
const AvailableOnOsIcon = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
        className: "available-on-os__icon-container__icon",
        ...props
    });
};
AvailableOnOsIcon.propTypes = {
    ...Icon/* default.propTypes */.Z.propTypes
};
AvailableOnOsIconContainer.Icon = AvailableOnOsIcon;
/* harmony default export */ var AvailableOnOs_Icon = (AvailableOnOsIconContainer);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/Body.js






const AvailableOnOsBody = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        className: "available-on-os__body",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
            sm: 12,
            ...props
        })
    });
};
AvailableOnOsBody.propTypes = {
    ...Grid/* Col.propTypes */.JX.propTypes
};
const Body_Item = (param)=>{
    let { sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        sx: {
            fontSize: "l",
            fontColor: "white",
            textAlign: "center",
            ...(0,pureProps/* default */.Z)(sx)
        },
        ...props
    });
};
Body_Item.propTypes = {
    sx: props_sx/* sxPropTypes */.I1,
    ...Paragraph/* default.propTypes */.Z.propTypes
};
AvailableOnOsBody.Item = Body_Item;
/* harmony default export */ var Body = (AvailableOnOsBody);

;// CONCATENATED MODULE: ./src/AvailableOnOs/index.js






const SectionTryForFree = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("available-on-os");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailableOnOs_AvailableOnOs, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailableOnOs_Icon, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableOnOs_Icon.Icon, {
                        name: "mac"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableOnOs_Icon.Icon, {
                        name: "windows"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body.Item, {
                    children: t("PRISM_IS")
                })
            })
        ]
    });
};
/* harmony default export */ var src_AvailableOnOs = (SectionTryForFree);

// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/Apps/Prism/index.js







































const PrismAnova = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("prism");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                    href: "https://www.graphpad.com/features"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                color: "gradient",
                align: "left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            lg: 10,
                            lgOffset: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Image/* default */.Z, {
                                            src: "/images/graphpad/prism/logo-prism-white.svg",
                                            className: "ml-m32--lg h-16"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                        lg: 8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                                sx: {
                                                    fontColor: "black--10"
                                                },
                                                spacing: {
                                                    mt: 5
                                                },
                                                children: t("HERO_DESCRIPTION")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                                                center: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_Grid/* HeroRow */.P, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                                href: "/demos/",
                                                                isBlock: true,
                                                                children: t("START_A_FREE_TRIAL")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                                href: "/how-to-buy/",
                                                                styleType: "info-light",
                                                                isOutline2: true,
                                                                isBlock: true,
                                                                children: t("PRICING")
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBackground/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Image/* default */.Z, {
                            src: "/images/graphpad/prism/hero-bg.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
                bgColor: "black--10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbar_Link/* default */.Z, {
                        Tag: NextLink/* default */.Z,
                        href: routes/* default.updates */.Z.updates,
                        children: [
                            t("DISCOVER"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "angle-right",
                                spacing: {
                                    ml: 1
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                id: "analysis",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("COMPREHENSIVE_ANALYSIS")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("ORGANIZE_YOUR_DATA")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("ORGANIZE_YOUR_DATA_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-multi-variables-w1182-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/sample_size.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("SAMPLE_SIZE")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default.Description */.Z.Description, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        children: t("SEMPLE_SIZE_DESC_0")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        children: t("SEMPLE_SIZE_DESC_1")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/features/power-analysis",
                                                    children: t("LEARN_MORE")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("PERFORM_THE_RIGHT_ANALYSIS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                                    children: [
                                                        t("PERFORM_THE_RIGHT_ANALYSIS_DESC1"),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: routes/* default.features.prismAnova */.Z.features.prismAnova,
                                                            children: t("ANOVA_LINK")
                                                        }),
                                                        ",",
                                                        t("PERFORM_THE_RIGHT_ANALYSIS_DESC2"),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: routes/* default.features.prismNonlinearRegression */.Z.features.prismNonlinearRegression,
                                                            children: t("NONLINEAR_REGRESSION_LINK")
                                                        }),
                                                        " ",
                                                        t("PERFORM_THE_RIGHT_ANALYSIS_DESC3"),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            href: routes/* default.features.prismSurvivalAnalysis */.Z.features.prismSurvivalAnalysis,
                                                            children: t("SURVIVAL_ANALYSIS_LINK")
                                                        }),
                                                        ", ",
                                                        t("PERFORM_THE_RIGHT_ANALYSIS_DESC4")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-t-test-w1076-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-welcome-dialog-w1059-800.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("GET_ACTIONABLE_HELP")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("GET_ACTIONABLE_HELP_DESC", {
                                                            link: "/prism-academy"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                isDark: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("WORK_SMARTER_NOT_HARDER")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-michaelis-w1102-800.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("ONE_CLICK_REGRESSION")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("ONE_CLICK_REGRESSION_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("FOCUS_ON_YOUR_RESEARCH")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("FOCUS_ON_YOUR_RESEARCH_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-xy-w1224-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-stars-on-graph-options-w1210-800.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("AUTOMATE_YOUR_WORK")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("AUTOMATE_YOUR_WORK_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                id: "graphing",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("THE_FASTEST_WAY")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("COUNTLESS_WAYS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("COUNTLESS_WAYS_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-customize-w1252-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/data-graph-inspector.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("EXPLORE_YOUR_DATA")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("EXPLORE_YOUR_DATA_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("EXPORT_PUBLICATION_QUALITY")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("EXPORT_PUBLICATION_QUALITY_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-publication-w1178-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/cloud/discuss-upd.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("ENHANCE_COLLABORATION")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("ENHANCE_COLLABORATION_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                utility: {
                    bgColor: "5"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        sx: {
                            fontColor: "white"
                        },
                        spacing: {
                            mb: 5
                        },
                        children: t("DISCOVER_WHATS_NEW")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.DescriptionV2 */.Z.DescriptionV2, {
                            sx: {
                                fontColor: "white"
                            },
                            children: t("INTRODUCING_AN_EVEN")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                Tag: "h3",
                                sx: {
                                    fontSize: "l",
                                    fontColor: "white",
                                    textAlign: "center"
                                },
                                spacing: {
                                    my: 15
                                },
                                children: t("ENHANCED_DATA_VISUALIZATION")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                        src: "/images/graphpad/prism/prism-bubble-w350-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                children: t("BUBBLE_PLOTS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                children: t("BUBBLE_PLOTS_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                        src: "/images/graphpad/prism/prism-violin-w350-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                children: t("VIOLIN_PLOTS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                children: t("VIOLIN_PLOTS_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                        src: "/images/graphpad/prism/prism-estimationplots-w350-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                children: t("ESTIMATION_PLOTS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                children: t("ESTIMATION_PLOTS_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                        src: "/images/graphpad/prism/prism-wn-smoothing-spline-w1281-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                children: t("SMOOTHING_SPLINE")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                children: t("SMOOTHING_SPLINE_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sx: {
                                        textAlign: "center"
                                    },
                                    spacing: {
                                        my: 10
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        sx: {
                                            fontSize: "xl",
                                            fontWeight: "medium",
                                            fontColor: "4",
                                            hover: {
                                                fontColor: "white"
                                            }
                                        },
                                        href: "/guides/prism/latest/user-guide/whats-new-highlights.htm",
                                        children: t("READ_MORE")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                    isGradient: true,
                                    spacing: {
                                        mb: 10
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    Tag: "h3",
                                    sx: {
                                        fontSize: "l",
                                        fontColor: "white",
                                        textAlign: "center"
                                    },
                                    spacing: {
                                        my: 15
                                    },
                                    children: t("IMPROVED_GRAPHING_AND_CUSTOMIZATION_OPTIONS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                            src: "/images/graphpad/prism/stars-on-graph.jpg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                    children: t("STARS_ON_GRAPH")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                    children: t("STARS_ON_GRAPH_DESC")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                            src: "/images/graphpad/prism/improved-graph-customization.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                    children: t("IMPROVED_GRAPH_CUSTOMIZATION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                    children: t("IMPROVED_GRAPH_CUSTOMIZATION_DESC")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                            src: "/images/graphpad/prism/prism-wn-automatically-label-bar-graphs-w1281-200.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                    children: t("AUTOMATICALLY_LABEL_BAR_GRAPHS")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("AUTOMATICALLY_LABEL_BAR_GRAPHS_DESC")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew_WhatIsNew, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image, {
                                            src: "/images/graphpad/prism/prism-wn-improved-group-graphs-w960-200.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Title, {
                                                    children: t("IMPROVED_GROUPED_GRAPHS")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content.Description, {
                                                    children: t("IMPROVED_GROUPED_GRAPHS_DESC")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        spacing: {
                                            my: 10
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            sx: {
                                                fontSize: "xl",
                                                fontWeight: "medium",
                                                fontColor: "4",
                                                hover: {
                                                    fontColor: "white"
                                                }
                                            },
                                            href: "/guides/prism/latest/user-guide/better-looking-graphs.htm",
                                            children: t("READ_MORE")
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h3",
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white",
                                                textAlign: "center"
                                            },
                                            children: t("MORE_INTUITIVE_NAVIGATION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("GREATER_COLLABORATION")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("GREATER_COLLABORATION_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("FAIR_DATA")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("FAIR_DATA_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("EXPANDED_DATA")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("EXPANDED_DATA_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("INTELLIGENT_DATA_WRANGLING")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("INTELLIGENT_DATA_WRANGLING_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("HOOK_CONSTANT")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("HOOK_CONSTANT_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                spacing: {
                                                    my: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                    sx: {
                                                        fontSize: "xl",
                                                        fontWeight: "medium",
                                                        fontColor: "4",
                                                        hover: {
                                                            fontColor: "white"
                                                        }
                                                    },
                                                    href: "/updates/prism-1000-release-notes",
                                                    children: t("READ_MORE")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h3",
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white",
                                                textAlign: "center"
                                            },
                                            children: t("NOW_FEATURING_EIGHT_KINDS_OF_DATA_TABLES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("XY_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("XY_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("COLUMN_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("COLUMN_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("GROUPED_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("GROUPED_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("CONTINGENCY_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("CONTINGENCY_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("SURVIVAL_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("SURVIVAL_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PARTS_OF_WHOLE_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PARTS_OF_WHOLE_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("MULTIPLE_VARIABLES_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("MULTIPLE_VARIABLES_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("NESTED_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("NESTED_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                spacing: {
                                                    my: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "xl",
                                                        fontWeight: "medium",
                                                        fontColor: "4",
                                                        hover: {
                                                            fontColor: "white"
                                                        }
                                                    },
                                                    href: "/guides/prism/latest/user-guide/using_data_table_format.htm",
                                                    children: t("READ_MORE")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h3",
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white",
                                                textAlign: "center"
                                            },
                                            children: t("MORE_SOPHISTICATED_STATISTICAL_ANALYSES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PERFORM_REPEATED")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PERFORM_REPEATED_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PERFORM_SIMPLE")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PERFORM_SIMPLE_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PRINCIPAL_COMPONENT_ANALYSIS")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PRINCIPAL_COMPONENT_ANALYSIS_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("MULTIPLE_T_TEST")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("MULTIPLE_T_TEST_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("ANALYZE_CATEGORICAL")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("ANALYZE_CATEGORICAL_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("INTERPOLATION_FROM_MULTIPLE")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("INTERPOLATION_FROM_MULTIPLE_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                spacing: {
                                                    my: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "xl",
                                                        fontWeight: "medium",
                                                        fontColor: "4",
                                                        hover: {
                                                            fontColor: "white"
                                                        }
                                                    },
                                                    href: "/guides/prism/latest/user-guide/repeated-measures-anova-with-m.htm",
                                                    children: t("READ_MORE")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionStart30DayTrial/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("DISCOVER_THE_BREADTH")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                            mx: true,
                            utility: {
                                justify: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 6,
                                    spacing: {
                                        px: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("STATISTICAL_COMPARISONS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_8")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_9")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_10")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("STATISTICAL_COMPARISONS_ITEM_11")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("STATISTICAL_COMPARISONS_ITEM_12")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_13")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_14")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_15")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_16")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_17")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("NONLINEAR_REGRESSION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_8")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_9")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_10")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_11")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_12")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_13")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_14")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_15")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_16")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_17")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_18")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_19")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_20")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("SURVIVAL_ANALYSIS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SURVIVAL_ANALYSIS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SURVIVAL_ANALYSIS_ITEM_2")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 6,
                                    spacing: {
                                        px: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("PRINCIPAL_COMPONENT_ANALYSIS_TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("PRINCIPAL_COMPONENT_ANALYSIS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("PRINCIPAL_COMPONENT_ANALYSIS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("PRINCIPAL_COMPONENT_ANALYSIS_ITEM_3")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("MULTIPLE_VARIABLE_GRAPHING")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("MULTIPLE_VARIABLE_GRAPHING_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("MULTIPLE_VARIABLE_GRAPHING_ITEM_2")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("COLUMN_STATISTICS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_8")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("COLUMN_STATISTICS_ITEM_9")
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("SIMPLE_LINEAR")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_8")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("GENERALIZED_LINEAR_MODELS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_4")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("CLINICAL_LAB_STATISTICS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("CLINICAL_LAB_STATISTICS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("CLINICAL_LAB_STATISTICS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("CLINICAL_LAB_STATISTICS_ITEM_3")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("SIMULATIONS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMULATIONS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMULATIONS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMULATIONS_ITEM_3")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("OTHER_CALCULATIONS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_8")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src_AvailableOnOs, {})
        ]
    });
};
/* harmony default export */ var Prism = ((0,pipe/* default */.Z)(PrismAnova, withErrorHandling/* default */.Z, services/* default */.ZP));

;// CONCATENATED MODULE: ./pages/features/index.js



/***/ }),

/***/ 15945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Line_Line; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/Line.js






const Line = (param)=>{
    let { className ="" , opacity ="" , isGradient =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("line", opacity && "line--opacity-".concat(opacity), isGradient && "line--gradient", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className)
    });
};
Line.propTypes = {
    className: prop_types.string,
    opacity: (0,prop_types.oneOf)([
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ]),
    isGradient: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Line_Line = (Line);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js



/***/ }),

/***/ 361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2349);
/* harmony import */ var _insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const PageNavbarItem = (param)=>/*#__PURE__*/ {
    let { spacing ={
        ..._insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .tF
    } , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("page-navbar-item", ...(0,_insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)(spacing)),
        children: children
    });
};
PageNavbarItem.propTypes = {
    spacing: _insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavbarItem);


/***/ }),

/***/ 24661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67924);






const PageNavbarLink = (param)=>/*#__PURE__*/ {
    let { Tag =_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , iconName , rotateIcon =false , children , className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("page-navbar-link", className),
        ...props,
        children: [
            iconName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                name: iconName,
                className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)(rotateIcon && "rotated-45")
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            })
        ]
    });
};
PageNavbarLink.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
            "a",
            "span",
            "button"
        ]),
        prop_types__WEBPACK_IMPORTED_MODULE_5__.elementType
    ]),
    iconName: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    rotateIcon: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavbarLink);


/***/ }),

/***/ 11794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageNavbar_PageNavbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/PageNavbar.js










const PageNavbar = (param)=>/*#__PURE__*/ {
    let { bgColor ="6" , alignHorizontal ="center" , withBorder =false , sticky =false , isFluid =false , fullWidthBorder =false , children , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            bgColor,
            ...fullWidthBorder ? {
                lg: {
                    border: {
                        bottom: {
                            width: 1,
                            color: "black--15"
                        }
                    }
                }
            } : {}
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), sticky && "page-navbar--sticky"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Container */.W2, {
            isFluid: isFluid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,classes/* classes */.S)("page-navbar", "align-horizontal--".concat(alignHorizontal)),
                            children: children
                        })
                    })
                }),
                withBorder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {}) : null
            ]
        })
    });
};
PageNavbar.propTypes = {
    alignHorizontal: (0,prop_types.oneOf)([
        "start",
        "end",
        "center",
        "between",
        "around"
    ]),
    children: prop_types.node,
    isFluid: prop_types.bool,
    sticky: prop_types.bool,
    fullWidthBorder: prop_types.bool,
    bgColor: prop_types.string,
    withBorder: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var PageNavbar_PageNavbar = (PageNavbar);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js



/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5568,8135,3284,6136,9365,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(30346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);